$(($) => {
    const nextStep = $('#next_step');
    const checkEmail = $('#check_email');
    const checkErrorResult = $('#check_errror_result');
    const checkStatus = $('#check_status');
    const goToPage = $('#go_to_page');
    const showDemoResult = $('#show_demo_result');
    const checkSite = $('#check_site');
    const siteUrl = $('#site_url');
    const email = $('#email');
    const type = $('#type');
    const checkResult = $('#check_result');
    const emailLabel = $('#email_label');
    checkResult.hide();
    checkEmail.hide();
    emailLabel.hide();
    checkErrorResult.hide();
    checkStatus.hide();
    goToPage.hide();
    showDemoResult.hide();

    nextStep.click(() => {
        if (siteUrl.val() === '') {
            checkErrorResult.html('Адрес сайта обязателен для заполнения');
            siteUrl.addClass('alert-danger');
            checkErrorResult.show();
            checkSite.attr('disabled', false);
        } else {
            siteUrl.removeClass('alert-danger');
            nextStep.hide();
            checkErrorResult.hide();
            checkEmail.show();
            emailLabel.show();
        }
    });
    checkSite.on('click', () => {
        checkResult.hide();
        checkSite.attr('disabled', true);
        checkErrorResult.hide();
        checkErrorResult.html('');
        if (siteUrl.val() === '') {
            siteUrl.addClass('alert-danger');
            checkErrorResult.html('<p>Адрес сайта обязателен для заполнения</p>');
        }
        if (email.val() === '') {
            email.addClass('alert-danger');
            checkErrorResult.append('<p>Email обязателен для заполнения</p>');
        }
        if (checkErrorResult.html() !== '') {
            checkErrorResult.show();
            checkSite.attr('disabled', false);
        } else {
            checkStatus.show();
            checkErrorResult.hide();
            siteUrl.removeClass('alert-danger');
            email.removeClass('alert-danger');
            $.get('/landing/check', {
                format: 'json',
                task: 'check',
                siteUrl: siteUrl.val(),
                email: email.val(),
                type: type.val(),
            }, (res) => {
                checkStatus.hide();
                if (!res.error) {
                    checkResult.show();
                    checkResult.find('#report_href').attr('href', res.link);
                    goToPage.show();
                } else {
                    checkErrorResult.html(res.error);
                    checkErrorResult.show();
                    checkSite.attr('disabled', false);
                }
                checkSite.attr('disabled', false);
            }, 'json')
                .fail(() => {
                    checkStatus.hide();
                    checkErrorResult.html('Произошла ошибка на стороне сервера');
                    checkErrorResult.show();
                    checkSite.attr('disabled', false);
                });
        }
    });
});
